import React from "react";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { useIntl } from "react-intl";
import "./index.scss";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import { END_POINTS } from "constants/APIConstant.js";

function ExternalTradePaid() {
  const intl = useIntl();

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);


  ReactGA.initialize(END_POINTS.TRACKING_ID)

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/external-trade-paid", title: "External Trade Paid Page" });
  }, []);


  return (
    <>
      <InnerHeader
        breadcrumb={[
          {
            title: intl.formatMessage({ id: "external-trade" }),
            clickClass: false,
          },
          {
            title: intl.formatMessage({ id: "unauthorized" }),
            clickClass: true,
          },
        ]}
        title={intl.formatMessage({ id: "unauthorized" })}
        route={"../external-trade"}
      />
      <div className="container d-flex align-items-center py-5">
        <div className="list-notes">
          <li>{intl.formatMessage({ id: "noteUnauthorized1" })}</li>
          <li>{intl.formatMessage({ id: "noteUnauthorized2" })}</li>
          <li>{intl.formatMessage({ id: "noteUnauthorized3" })}</li>
          <li className="mb-1">
            {intl.formatMessage({ id: "noteUnauthorized4" })}
          </li>

          <Link to={"../register"}>
            {intl.formatMessage({ id: "subscription-options-prices" })}
          </Link>

          <li className="mb-1 mt-2">
            {intl.formatMessage({ id: "noteUnauthorized5" })}
          </li>

          <Link to={"../contact"}>
            {intl.formatMessage({ id: "contact-us" })}
          </Link>

          <li className="mb-0 mt-2">
            {intl.formatMessage({ id: "noteUnauthorized6" })}
          </li>
        </div>
      </div>
    </>
  );
}

export default ExternalTradePaid;
